module.exports = __webpack_public_path__ + "images/marketing/features/track-email.png";